import '../styles/toast.css';

const META = {
  success: { label: 'Success',    icon: '✓' },
  error:   { label: 'Error', icon: '✕' },
  info:    { label: 'Notice',         icon: '◈' },
};

export default function Toast({ toasts, dismiss }) {
  if (!toasts.length) return null;
  return (
    <div className="toast-container" aria-live="polite" aria-atomic="false">
      {toasts.map(t => {
        const m = META[t.type] ?? META.info;
        return (
          <div
            key={t.id}
            className={`toast toast-${t.type}`}
            role="alert"
            onClick={() => dismiss(t.id)}
          >
            <span className="toast-icon" aria-hidden="true">{m.icon}</span>
            <div className="toast-body">
              <span className="toast-label">{m.label}</span>
              <span className="toast-msg">{t.msg}</span>
            </div>
            <button
              type="button"
              className="toast-close"
              aria-label="Dismiss"
              onClick={e => { e.stopPropagation(); dismiss(t.id); }}
            >×</button>
            {t.duration > 0 && (
              <div
                className="toast-progress"
                style={{ animationDuration: `${t.duration}ms` }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
